var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 41,
    viewBox: "0 0 40 41",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 41,
    maskUnits: "userSpaceOnUse",
    width: 40,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .5h40v40h-40z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.0028 20.222c.8409 0 1.5599-.2994 2.1571-.8983.5972-.5986.8958-1.3185.8958-2.1596 0-.8408-.2994-1.5599-.8983-2.1571-.5986-.5972-1.3185-.8958-2.1596-.8958-.8408 0-1.5598.2994-2.1571.8983-.5972.5986-.8958 1.3185-.8958 2.1596 0 .8408.2995 1.5598.8983 2.1571.5987.5972 1.3185.8958 2.1596.8958zm-.0025 13.2779c3.5925-3.2778 6.2499-6.2523 7.9721-8.9237 1.7222-2.6711 2.5833-5.0299 2.5833-7.0763 0-3.1905-1.0188-5.803-3.0566-7.83748-2.0378-2.03417-4.5374-3.05125-7.4988-3.05125s-5.4609 1.01708-7.4987 3.05125c-2.0378 2.03448-3.05669 4.64698-3.05669 7.83748 0 2.0464.87499 4.4052 2.62499 7.0763 1.75 2.6714 4.3935 5.6459 7.9304 8.9237zm0 3.6667c-4.4722-3.8056-7.8125-7.3403-10.02081-10.6042-2.20833-3.2639-3.3125-6.2847-3.3125-9.0625 0-4.1666 1.34028-7.4861 4.02081-9.95831 2.6806-2.47223 5.7847-3.70834 9.3125-3.70834s6.632 1.23611 9.3125 3.70834c2.6806 2.47221 4.0209 5.79171 4.0209 9.95831 0 2.7778-1.1042 5.7986-3.3125 9.0625-2.2084 3.2639-5.5487 6.7986-10.0209 10.6042z",
    fill: "#1c1b1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8827f8f2bbc19db730b79e9894d7cca6.svg";
export { ForwardRef as ReactComponent };